import { useEffect, useRef } from 'react'

/**
 * A hook that calls a callback function at a specified interval.
 * @param callback Your custom lambda or function to execute at the interval.
 * @param delayMs The interval in milliseconds. Zero means no timeout and ignore callback.
 */
export function useInterval(callback: () => unknown, delayMs: number) {
  const savedCallback = useRef<() => unknown>(() => {})

  // This is the key to how this works with React's state management. The setInterval() 
  // function's callback has its own scope. What that object keeps track of is a reference to 
  // your actual callback. The latest version. Regardless of when setInterval() was called.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    if (!delayMs || delayMs <= 0) return  // Zero or negative delay deactivates this hook
    const id = setInterval(() => savedCallback.current(), delayMs)
    return () => clearInterval(id)
  }, [delayMs])

}
